import { Component, Input, OnInit } from '@angular/core';
import { GooglePatternNumberFormatter } from '../../services/google-pattern-number-formatter';

@Component({
    selector: 'google-ecommerce-transaction',
    templateUrl: './google-ecommerce-transaction.component.html'
})
export class GoogleEcommerceTransactionComponent implements OnInit {
    @Input('offer') offer;
    @Input('isOrder') isOrder;
    @Input('isSubscription') isSubscription;

    public transaction: TransactionInterface = null;
    public items: Array<TransactionItemInterface> = [];

    constructor(protected googlePatternNumberFormatter: GooglePatternNumberFormatter) {
    }

    ngOnInit() {
        this.transaction = {
            'id': this.transactionId(),
            'revenue': this.googlePatternNumberFormatter.transform(this.loadRevenue()),
            'shipping': this.googlePatternNumberFormatter.transform(this.offer.freight)
        };
        this.fillOrderItems();
        this.fillSubscriptionPlan();
    }

    /**
     * Load transaction id from offer id.
     **/
    private transactionId() {
        return `${this.transactionIdPrefix()}${+this.offer.id}`;
    }
    /**
     * Get transaction id prefix.
     **/
    private transactionIdPrefix() {
        if (this.isOrder) {
            return window['googleEcommerceTransactionOrderTransactionPrefix'] || '';
        }
        if (this.isSubscription) {
            return window['googleEcommerceTransactionSubscriptionTransactionPrefix'] || '';
        }

        return '';
    }
    /**
     * Load renevue value from order subtotal or plan amount.
     **/
    private loadRevenue() {
        if (this.offer.plan !== undefined) {
            return this.offer.plan.amount;
        }

        return this.offer.subtotal;
    }
    /**
     * Loop into order items to push into transaction item array.
     **/
    private fillOrderItems() {
        if (this.offer.items !== undefined) {
            const itemIdPrefix = window['googleEcommerceTransactionItemIdPrefix'] || '';

            for (let item of this.offer.items) {
                this.items.push({
                    id: this.transactionId(),
                    name: item.item.name,
                    sku: `${itemIdPrefix}${item.item.id}`,
                    price: this.googlePatternNumberFormatter.transform(item.unit_price),
                    quantity: parseInt(item.quantity, 10).toFixed(0)
                });
            }
        }
    }
    /**
     * Fill subscription plan details into items.
     **/
    private fillSubscriptionPlan() {
        if (this.offer.plan !== undefined) {
            const planIdPrefix = window['googleEcommerceTransactionPlanIdPrefix'] || '';

            this.items.push({
                id: this.transactionId(),
                name: this.offer.plan.description,
                sku: `${planIdPrefix}${this.offer.plan.id}`,
                price: this.googlePatternNumberFormatter.transform(this.offer.plan.amount),
                quantity: '1'
            });
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/shared/components/google-ecommerce-transaction/google-ecommerce-transaction.component.ts